import script from "./PixPendingPayment.vue?vue&type=script&lang=ts&setup=true"
export * from "./PixPendingPayment.vue?vue&type=script&lang=ts&setup=true"

import "./PixPendingPayment.vue?vue&type=style&index=0&id=7459248c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7459248c"]])

export default __exports__